<template>
  <div class="page-container">
    <div class="settings-container">
      <section-title>
        Share this link with your friends so they can join
      </section-title>
      <input :value="gameLink" class="share-link" :href="gameLink"/>
    </div>

    <div class="player-name" v-if="!isJoinVisible">
      <section-title>
        Your Name
      </section-title>
      <input
        class="player-name-field"
        v-model="playerName"
        placeholder="Type your name"
      />

      <p v-if="tooManyPlayers">
        This game is full. No more players allowed.
      </p>

      <o-button
        :disabled="tooManyPlayers"
        @click="onClickJoinGame"
        stretch
      >
        Join Game
      </o-button>
    </div>

    <div class="lobby-container">
      <section-title>
        <template v-if="!isLobbyFull">
          Need {{ playersNeededToStart }} players to join before you can start the game.
        </template>

        <template v-if="isLobbyOverfilled">
          Too many people have joined the game. Please kick someone out before you can start the game.
        </template>

        <template v-if="!isLobbyOverfilled && isLobbyFull">
          Start the game already!
        </template>
      </section-title>

      <p class="empty-state" v-if="isLobbyEmpty">No one has joined the game yet</p>

      <ul class="player-name-list">
        <li
          class="player-row"
          v-for="player in players"
          :key="player.id"
        >
          <span>{{ player.name }}</span>
<!--          <o-button-->
<!--            :disabled="isKickDisabled(player.id)"-->
<!--            @click="kickPlayer(player.id)"-->
<!--          >-->
<!--            Kick Player-->
<!--          </o-button>-->
        </li>
      </ul>

      <o-button
        :disabled="isStartButtonDisabled"
        @click="onStartGame"
        stretch
      >
        Start Game
      </o-button>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { NS_GAME_STATE } from "@/store/constants";
import TooManyPlayers from "@/exceptions/TooManyPlayers";
import SectionTitle from "@/components/SectionTitle";
import OButton from "@/components/OButton";

export default {
  name: 'GameLobby',
  components: {OButton, SectionTitle},
  data() {
    return {
      playerName: '',
      tooManyPlayers: false,
    }
  },

  computed: {
    ...mapGetters(NS_GAME_STATE, [
      'gameId',
      'localStoragePlayerId',
      'players',
      'numberOfPlayers',
      'hasGameStarted',
    ]),

    gameLink() {
      return location.href;
    },

    isJoinVisible() {
      return this.localStoragePlayerId;
    },

    numberOfPlayersJoined() {
      return Object.values(this.players).length;
    },

    isLobbyEmpty() {
      return this.numberOfPlayersJoined <= 0;
    },

    isLobbyFull() {
      return this.numberOfPlayersJoined == this.numberOfPlayers;
    },

    playersNeededToStart() {
      return this.numberOfPlayers - this.numberOfPlayersJoined
    },

    isLobbyOverfilled() {
      return this.numberOfPlayersJoined > this.numberOfPlayers;
    },

    isStartButtonDisabled() {
      return this.hasGameStarted || this.isLobbyOverfilled || !this.isLobbyFull;
    },
  },

  methods: {
    ...mapActions(NS_GAME_STATE, {
      createNewGame: 'createNewGame',
      joinGame: 'joinGame',
      startGame: 'startGame',
      kickPlayer: 'kickPlayer',
    }),

    async onClickJoinGame() {
      try {
        await this.joinGame({
          name: this.playerName,
        });
      } catch(e) {
        if (e instanceof TooManyPlayers) {
          this.tooManyPlayers = true;
          return;
        }

        throw e;
      }
    },

    isKickDisabled(playerId) {
      return this.localStoragePlayerId === playerId;
    },

    onStartGame() {
      this.startGame();
    },

    isOnline(playerId) {
      return this.players[playerId].isOnline;
    }
  },
}
</script>

<style scoped>
.page-container {
  display: flex;
  flex-direction: column;
}

.settings-container,
.player-name,
.lobby-container
{
  border-left: 1px solid #00000026;
  border-right: 1px solid #00000026;
  border-bottom: 1px solid #00000026;
}

.player-name,
.lobby-container
{
  margin-top: 25px;
}

.share-link {
  width: 100%;
  padding: 11px 5px;
  box-sizing: border-box;
  font-size: 17px;
  border: 0;
  text-align: center;
}

.player-name-field {
  margin: 10px;
  width: calc(100% - 20px);
  box-sizing: border-box;
  padding: 8px 10px;
  border-radius: 5px;
  border: 1px solid #0000003d;
}

.empty-state {
  margin: 50px;
  text-align: center;
}

.player-name-list {
  margin: 25px;
}

.player-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
}
</style>
